<div class="thank-you">
  <!-- Figma: grey close tab sits above the card's top-right corner, behind the card -->
  <button type="button" class="thank-you__close" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <div class="thank-you__card">
    <div class="thank-you__title">
      {{ "missingVehicleInfo.thankYouTitle" | translate }}
    </div>
    <div class="thank-you__desc">
      {{ "missingVehicleInfo.thankYouDesc" | translate }}
    </div>
    <button type="button" mat-flat-button class="thank-you__btn" mat-dialog-close>
      {{ "missingVehicleInfo.close" | translate }}
    </button>
  </div>
</div>
